/* Supplier basket: supplier-order parts are kept in localStorage and
   shown on the cart page next to the normal Shopify cart. When it has lines,
   Checkout sends the Shopify cart (variant IDs + quantities only) and the
   supplier lines to the search service, which prices everything server-side,
   creates ONE Shopify draft order and returns its checkout (invoice) URL.
   With no supplier lines the normal Shopify checkout is untouched. */
(function () {
  'use strict';
  var KEY = 'shire-supplier-basket-v1';
  var LAST = 'shire-supplier-last-checkout';
  var DEL = 'shire-supplier-delivery-v1';
  var COUNTRIES = [['GB', 'United Kingdom'], ['JE', 'Jersey'], ['GG', 'Guernsey'], ['IM', 'Isle of Man']];
  var QMAX = 20;

  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function write(a) {
    try { if (a.length) localStorage.setItem(KEY, JSON.stringify(a)); else localStorage.removeItem(KEY); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('supplier-basket:change')); } catch (e) {}
  }
  function count() { return read().reduce(function (n, l) { return n + (l.qty || 0); }, 0); }
  function keyOf(l) { return l.make + '|' + l.code; }
  function add(item) {
    var a = read(), k = keyOf(item), hit = null;
    a.forEach(function (l) { if (keyOf(l) === k) hit = l; });
    if (hit) hit.qty = Math.min(QMAX, (hit.qty || 0) + 1);
    else a.push({ make: item.make, makeName: item.makeName, code: item.code, description: item.description, exVat: item.exVat, incVat: item.incVat, pattern: !!item.pattern, qty: 1, at: Date.now() });
    write(a);
    return hit ? hit.qty : 1;
  }
  function setQty(k, q) {
    q = Math.max(1, Math.min(QMAX, parseInt(q, 10) || 1));
    var a = read(); a.forEach(function (l) { if (keyOf(l) === k) l.qty = q; }); write(a);
  }
  function remove(k) { write(read().filter(function (l) { return keyOf(l) !== k; })); }
  function clear() { write([]); }
  function pence(v) { return Math.round(Number(v) * 100); }
  /* Same rounding Shopify uses for a taxable line: VAT on the line total. */
  function lineTotals(l) {
    var ex = pence(l.exVat) * (l.qty || 1), vat = Math.round(ex * 0.2);
    return { ex: ex, inc: ex + vat };
  }
  function gbp(p) { return '\u00a3' + (p / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Header badge = Shopify cart count + supplier basket count. */
  function setBadge(shopCount) {
    var link = document.querySelector('.header__cart');
    if (!link) return;
    var n = (parseInt(shopCount, 10) || 0) + count();
    var badge = link.querySelector('.header__cart-badge');
    if (n > 0) {
      link.classList.add('header__cart--live');
      if (!badge) { badge = document.createElement('span'); badge.className = 'header__cart-badge'; link.appendChild(badge); }
      badge.textContent = String(n);
    } else {
      link.classList.remove('header__cart--live');
      if (badge) badge.parentNode.removeChild(badge);
    }
  }
  function refreshBadge() {
    /* Also refresh when the supplier basket is empty but a badge is showing, so removing the last
       supplier part (here, on another page or in another tab) brings the count back down. */
    if (!count() && !document.querySelector('.header__cart-badge')) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBadge(c && c.item_count); })
      .catch(function () {});
  }

  /* ---------------- official add path (shared by basket links and the Saved page) ----------------
     A supplier part is only ever added from a fresh lookup in the live supplier catalogue (the search
     service), on the same terms as the search page's "Add to basket": exact make + part number, priced,
     not a part we now sell in the shop. Prices/descriptions never come from a link or from Saved; the
     service re-prices and re-checks everything (exclusions, minimum, VAT) again at checkout. */
  var API_FALLBACK = 'https://shire-supplier-search.jack-blackwell.workers.dev';
  var SAVED = 'shire-supplier-saved-v1';
  var PENDING = 'shire-supplier-pending-link';
  var LINK_MAX = 20;
  function apiBase() {
    var el = document.querySelector('[data-supplier-cart][data-supplier-api]') || document.querySelector('[data-supplier-order][data-api]');
    var v = el ? (el.getAttribute('data-supplier-api') || el.getAttribute('data-api') || '') : '';
    v = v.replace(/\/+$/, '');
    return v && !/REPLACE/.test(v) ? v : API_FALLBACK;
  }
  function norm(c) { return String(c || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function soldInShop(st) { return !!(st && st.handle && st.kind !== 'kit'); }
  var lookups = {};
  function lookup(make, code) {
    make = String(make || '').toUpperCase();
    var k = make + '|' + norm(code);
    if (lookups[k]) return lookups[k];
    if (!/^[A-Z]{2}$/.test(make) || norm(code).length < 3) return Promise.resolve({ ok: false, reason: 'invalid' });
    var p = fetch(apiBase() + '/search?q=' + encodeURIComponent(code) + '&make=' + make + '&page=1', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        if (d && d.type === 'make') return { ok: false, reason: 'make', message: d.message || '' };
        var row = null;
        ((d && d.results) || []).forEach(function (x) { if (!row && x && x.make === make && norm(x.code) === norm(code)) row = x; });
        if (!row) return { ok: false, reason: 'gone' };
        if (soldInShop(row.stocked)) return { ok: false, reason: 'stocked', row: row, stocked: row.stocked };
        if (row.replacedBy && soldInShop(row.replacedBy.stocked)) return { ok: false, reason: 'stocked', row: row, stocked: row.replacedBy.stocked };
        if (row.incVat == null || row.exVat == null) return { ok: false, reason: 'poa', row: row };
        return { ok: true, row: row };
      })
      .catch(function () { delete lookups[k]; return { ok: false, reason: 'network' }; });
    lookups[k] = p;
    return p;
  }
  /* mode 'set': the line ends up at exactly qty (basket links); otherwise +qty (Saved page). */
  function addChecked(make, code, qty, mode) {
    return lookup(make, code).then(function (res) {
      if (!res.ok) return res;
      var q = add(res.row);
      var want = mode === 'set' ? qty : q - 1 + (qty || 1);
      if (want !== q) setQty(keyOf(res.row), want);
      return res;
    });
  }
  function reasonText(res) {
    switch (res && res.reason) {
      case 'gone': return 'no longer available from our supplier';
      case 'poa': return 'now price on request, so it can\u2019t be ordered online';
      case 'stocked': return 'we now sell this part in the shop';
      case 'make': return res.message || 'we can\u2019t take supplier orders for this make at the moment';
      case 'invalid': return 'not a valid part number';
      default: return 'couldn\u2019t be checked just now (connection problem)';
    }
  }
  function makeName(make, fallback) {
    var M = { BM: 'BMW', DU: 'Ducati', HO: 'Honda', KA: 'Kawasaki', PI: 'Piaggio', SU: 'Suzuki', TR: 'Triumph', YA: 'Yamaha' };
    return fallback || M[make] || make;
  }
  function stockedLink(res) {
    return res && res.stocked && res.stocked.handle
      ? ' <a href="/products/' + esc(encodeURIComponent(res.stocked.handle)) + '">View part</a>' : '';
  }

  /* ---------------- basket links: ?load=ID:QTY,...&sup=MAKE:CODE:QTY,... ---------------- */
  function shareParam() {
    return read().slice(0, LINK_MAX).map(function (l) {
      return String(l.make).toUpperCase() + ':' + encodeURIComponent(l.code) + ':' + Math.max(1, Math.min(QMAX, parseInt(l.qty, 10) || 1));
    }).join(',');
  }
  function parseLink(raw) {
    var lines = [];
    String(raw || '').split(',').slice(0, LINK_MAX).forEach(function (part) {
      var b = part.split(':');
      if (b.length < 2) return;
      var make = String(b[0]).toUpperCase(), code;
      try { code = decodeURIComponent(b[1]).trim(); } catch (e) { return; }
      var q = parseInt(b[2], 10) || 1;
      if (!/^[A-Z]{2}$/.test(make) || !/^[A-Za-z0-9][A-Za-z0-9 .\/\-]{2,39}$/.test(code)) return;
      lines.push({ make: make, code: code, qty: Math.max(1, Math.min(QMAX, q)) });
    });
    return lines;
  }
  /* theme.js (initCartLoadFromShare) reloads /cart after re-adding ?load= lines, so the supplier
     lines are parked in sessionStorage and restored on the cart page that follows. */
  var themeWillReload = false;
  (function takeLink() {
    var m = /[?&]sup=([^&#]*)/.exec(window.location.search);
    if (!m) return;
    var lines = parseLink(m[1]);
    try { sessionStorage.setItem(PENDING, JSON.stringify({ lines: lines, at: Date.now() })); } catch (e) { return; }
    var load = /[?&]load=([^&#]*)/.exec(window.location.search);
    themeWillReload = !!(load && decodeURIComponent(load[1]).split(',').some(function (p) {
      var b = String(p || '').trim().split(':'); return Number(b[0]) > 0 && Number(b[1] || 1) > 0;
    }));
  })();

  /* ---------------- Saved supplier parts (identity only; the price is always fetched live) ---------------- */
  function savedRead() {
    try { var a = JSON.parse(localStorage.getItem(SAVED) || '[]'); return Array.isArray(a) ? a.filter(function (l) { return l && l.make && l.code; }) : []; } catch (e) { return []; }
  }
  function savedWrite(a) {
    try { if (a.length) localStorage.setItem(SAVED, JSON.stringify(a)); else localStorage.removeItem(SAVED); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('supplier-saved:change')); } catch (e) {}
  }
  function savedHas(k) { return savedRead().some(function (l) { return keyOf(l) === k; }); }
  function savedToggle(row) {
    var k = keyOf(row), a = savedRead();
    if (a.some(function (l) { return keyOf(l) === k; })) { savedWrite(a.filter(function (l) { return keyOf(l) !== k; })); return false; }
    a.unshift({ make: row.make, makeName: row.makeName, code: row.code, description: row.description, pattern: !!row.pattern, savedAt: Date.now() });
    savedWrite(a);
    return true;
  }
  function savedRemove(k) { savedWrite(savedRead().filter(function (l) { return keyOf(l) !== k; })); }
  function savedHref(l) { return '/search?view=supplier-order&q=' + encodeURIComponent(l.code) + '&make=' + encodeURIComponent(l.make); }
  var BOX_SVG = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/></svg>';
  function savedRowHtml(l) {
    var k = esc(keyOf(l)), href = esc(savedHref(l));
    return '<div class="saved-row saved-row--supplier" data-supplier-saved-key="' + k + '">' +
      '<a class="saved-row__media saved-row__media--supplier" href="' + href + '" tabindex="-1" aria-hidden="true"><span>' + BOX_SVG + '</span></a>' +
      '<div class="saved-row__info">' +
        '<a class="saved-row__title" href="' + href + '">' + esc(makeName(l.make, l.makeName)) + ' ' + esc(l.code) + '</a>' +
        (l.description ? '<p class="supplier-saved__desc">' + esc(l.description) + '</p>' : '') +
        '<p class="supplier-saved__tag">' + (l.pattern ? '<span class="supplier-saved__label">Pattern/aftermarket</span>' : '') + '<span class="bo-badge">Backordered 1\u20134 weeks</span></p>' +
        '<div class="saved-row__price supplier-saved__price" data-supplier-saved-price aria-live="polite"><span class="supplier-saved__skel" aria-hidden="true"></span><span class="visually-hidden">Checking today\u2019s price\u2026</span></div>' +
        '<div class="saved-row__actions">' +
          '<button type="button" class="button button--secondary" data-supplier-saved-add="' + k + '">Add to cart</button>' +
          '<button type="button" class="saved-row__remove" data-supplier-saved-remove="' + k + '">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }
  function paintSavedRow(el, res) {
    var price = el.querySelector('[data-supplier-saved-price]'), btn = el.querySelector('[data-supplier-saved-add]');
    if (!price) return;
    el.classList.toggle('is-unavailable', !res.ok && res.reason !== 'network');
    if (res.ok) {
      var ex = pence(res.row.exVat), inc = pence(res.row.incVat);
      price.innerHTML = '<span class="supplier-saved__inc">' + gbp(inc) + ' <span class="price-vat__label">inc VAT</span></span>' +
        '<span class="supplier-saved__ex">' + gbp(ex) + ' <span class="price-vat__label">ex VAT</span></span>';
      if (btn) btn.hidden = false;
      return;
    }
    if (res.reason === 'network') {
      price.innerHTML = '<span class="supplier-saved__muted">Price unavailable right now</span>';
      if (btn) btn.hidden = false;
      return;
    }
    price.innerHTML = '<span class="supplier-saved__gone">' + (res.reason === 'stocked' ? 'Now sold in our shop' : 'No longer available') + '</span>' +
      '<span class="supplier-saved__why">' + esc(res.reason === 'stocked' ? 'This part is now sold in the shop.' : 'This part is ' + reasonText(res) + '.') + stockedLink(res) + '</span>';
    if (btn) btn.hidden = true;
  }
  function savedHydrate(container) {
    Array.prototype.forEach.call((container || document).querySelectorAll('[data-supplier-saved-key]'), function (el) {
      var k = el.getAttribute('data-supplier-saved-key'), i = k.indexOf('|');
      lookup(k.slice(0, i), k.slice(i + 1)).then(function (res) { if (el.isConnected) paintSavedRow(el, res); });
    });
  }
  /* theme.js renderPage(): merge supplier rows into the Saved list, newest first. */
  function savedRenderInto(listEl, productItems) {
    if (!listEl) return;
    var rows = [];
    Array.prototype.forEach.call(listEl.children, function (el, i) { rows.push({ t: Number(productItems && productItems[i] && productItems[i].savedAt) || 0, el: el }); });
    var tmp = document.createElement('div');
    savedRead().forEach(function (l) {
      tmp.innerHTML = savedRowHtml(l);
      rows.push({ t: Number(l.savedAt) || 0, el: tmp.firstChild });
    });
    rows.sort(function (a, b) { return b.t - a.t; });
    rows.forEach(function (r) { listEl.appendChild(r.el); });
    savedHydrate(listEl);
  }
  function savedAddAll() {
    var a = savedRead(), added = 0, failed = [];
    return a.reduce(function (chain, l) {
      return chain.then(function () {
        return addChecked(l.make, l.code, 1).then(function (res) {
          if (res.ok) added++; else failed.push({ l: l, res: res });
        });
      });
    }, Promise.resolve()).then(function () {
      refreshBadge();
      var foot = document.querySelector('[data-saved-foot]');
      if (foot) {
        var note = foot.querySelector('[data-supplier-saved-note]');
        if (!note) { note = document.createElement('p'); note.className = 'supplier-saved-note'; note.setAttribute('data-supplier-saved-note', ''); note.setAttribute('role', 'status'); foot.appendChild(note); }
        note.innerHTML = failed.length ? failHtml(failed, 'saved') : '';
        note.hidden = !failed.length;
      }
      return { added: added, failed: failed };
    });
  }
  function failHtml(failed, where) {
    var n = failed.length;
    return '<strong>' + n + ' backorder part' + (n === 1 ? '' : 's') + ' couldn\u2019t be added' + (where === 'link' ? ' from the link' : '') + '</strong>' +
      '<ul>' + failed.map(function (f) {
        return '<li>' + esc(makeName(f.l.make, f.l.makeName)) + ' ' + esc(f.l.code) + ' \u2014 ' + esc(reasonText(f.res)) + '.' + stockedLink(f.res) + '</li>';
      }).join('') + '</ul>';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var addB = t.closest && t.closest('[data-supplier-saved-add]');
    if (addB) {
      e.preventDefault();
      if (addB.disabled) return;
      var k = addB.getAttribute('data-supplier-saved-add'), i = k.indexOf('|'), row = addB.closest('[data-supplier-saved-key]');
      addB.disabled = true; addB.textContent = 'Adding\u2026';
      addChecked(k.slice(0, i), k.slice(i + 1), 1).then(function (res) {
        if (row) paintSavedRow(row, res);
        if (res.ok) {
          refreshBadge();
          addB.textContent = 'Added';
          setTimeout(function () { addB.disabled = false; addB.textContent = 'Add to cart'; }, 1200);
        } else {
          addB.disabled = false;
          addB.textContent = res.reason === 'network' ? 'Try again' : 'Add to cart';
        }
      });
      return;
    }
    var rmB = t.closest && t.closest('[data-supplier-saved-remove]');
    if (rmB) { e.preventDefault(); savedRemove(rmB.getAttribute('data-supplier-saved-remove')); }
  });
  window.SupplierSaved = {
    read: savedRead, has: savedHas, toggle: savedToggle, remove: savedRemove,
    clear: function () { savedWrite([]); }, count: function () { return savedRead().length; },
    renderInto: savedRenderInto, addAll: savedAddAll, lookup: lookup
  };

  window.SupplierBasket = { read: read, add: add, setQty: setQty, remove: remove, clear: clear, count: count, refreshBadge: refreshBadge, lineTotals: lineTotals, shareParam: shareParam, addChecked: addChecked, lookup: lookup };

  /* ---------------- Checkout resume (2026-09-26) ----------------
     Starting a supplier checkout no longer empties the baskets. The pending draft order is
     remembered (LAST: url, name, id, key, sig, lines, api); going back keeps every line
     editable. Checkout again with the same basket reuses the pending draft; a changed basket
     replaces it. Only when the Worker reports the draft COMPLETED (paid) are the ordered lines
     removed, on whichever page the customer lands next. */
  function readLast() { try { var l = JSON.parse(localStorage.getItem(LAST) || 'null'); return l && typeof l === 'object' ? l : null; } catch (e) { return null; } }
  function dropLast() { try { localStorage.removeItem(LAST); } catch (e) {} }
  function basketSig(cart, delivery) {
    var s = read().map(function (l) { return keyOf(l) + '*' + (l.qty || 1); }).sort();
    var c = ((cart && cart.items) || []).map(function (i) { return i.variant_id + '*' + i.quantity; }).sort();
    return JSON.stringify([s, c, delivery ? [delivery.country || '', String(delivery.zip || '').toUpperCase().replace(/\s+/g, ''),
      delivery.name || '', delivery.address1 || '', delivery.address2 || '', delivery.city || '', delivery.phone || ''] : []]);
  }
  function lastStatus(last) {
    if (!last || !last.id || !last.key || !last.api) return Promise.resolve(null);
    return fetch(last.api + '/checkout-status?id=' + encodeURIComponent(last.id) + '&key=' + encodeURIComponent(last.key), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return j && j.status ? j.status : null; }).catch(function () { return null; });
  }
  /* The draft was paid: remove exactly the ordered lines (anything added since stays). */
  function clearOrdered(last) {
    var gone = {};
    (last.lines && last.lines.sup || []).forEach(function (k) { gone[k] = true; });
    write(read().filter(function (l) { return !gone[keyOf(l)]; }));
    dropLast();
    var want = (last.lines && last.lines.cart) || {};
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var upd = {}, any = false;
        ((cart && cart.items) || []).forEach(function (i) {
          var q = want[i.variant_id];
          if (q) { upd[i.key] = Math.max(0, i.quantity - q); any = true; }
        });
        if (!any) return cart;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ updates: upd }) })
          .then(function (r) { return r.json(); });
      }).catch(function () { return null; });
  }
  /* Site-wide: at most once a minute, ask whether the pending checkout has been paid. */
  function checkPaid() {
    var last = readLast();
    if (!last || !last.key) return Promise.resolve(null);
    if (Date.now() - (last.at || 0) > 7 * 86400000) { dropLast(); return Promise.resolve(null); }
    try {
      var t = Number(sessionStorage.getItem(LAST + '-checked') || 0);
      if (Date.now() - t < 60000 && !document.querySelector('[data-supplier-cart]')) return Promise.resolve(null);
      sessionStorage.setItem(LAST + '-checked', String(Date.now()));
    } catch (e) {}
    return lastStatus(last).then(function (st) {
      if (st === 'completed') {
        return clearOrdered(last).then(function () {
          try { sessionStorage.setItem(LAST + '-paid', last.name || '1'); } catch (e) {}
          if (document.querySelector('[data-supplier-cart]')) { window.location.replace('/cart'); return 'reload'; }
          refreshBadge();
          return 'completed';
        });
      }
      if (st === 'gone') dropLast();
      return st;
    });
  }

  /* ---------------- cart page ---------------- */
  function initCart() {
    var root = document.querySelector('[data-supplier-cart]');
    if (!root) return;
    var api = (root.getAttribute('data-supplier-api') || '').replace(/\/+$/, '');
    var box = root.querySelector('[data-supplier-basket]');
    var subtotalEl = document.querySelector('[data-supplier-subtotal]');
    var emptyWrap = document.querySelector('[data-supplier-empty]');
    var emptyMsg = document.querySelector('[data-cart-empty-msg]');
    var form = box ? box.closest('form') : null;
    var errEls = document.querySelectorAll('[data-supplier-error]');
    var resume = document.querySelector('[data-supplier-resume]');
    var minEx = 0;                                   // pence ex VAT, from the service /config (whole basket)
    var stockEx = 0;                                 // pence ex VAT of the normal Shopify cart lines (they count too)
    var minText = root.getAttribute('data-supplier-min-text') || 'Orders with backorder parts have a [minimum] + VAT minimum for the whole cart. Add [remaining] + VAT more to check out.';
    var ackText = root.getAttribute('data-supplier-ack-text') || 'I\u2019ve checked my part numbers and understand my whole order, including any in-stock items, will be sent together once the backorder parts arrive.';
    var holdText = root.getAttribute('data-supplier-hold-text') || 'In stock \u00b7 held and sent with your backorder parts';
    /* Cart pills: next to the green pill only the note is shown ("In stock" is the pill). */
    var holdNote = holdText.replace(/^\s*in stock\s*[\u00b7\u2022\-\u2013,:]?\s*/i, '') || holdText;
    var caveats = (root.getAttribute('data-supplier-caveats') || '').split(/\n+/).map(function (t) { return t.replace(/^[\s\u2022-]+/, '').trim(); }).filter(Boolean);

    /* Caveats + delivery country/postcode + minimum note, placed after the supplier rows. */
    var panel = null, minEl = null, selEl = null, zipEl = null, ackEl = null, addrEls = {}, sumEl = null;
    if (box) {
      var del = {}; try { del = JSON.parse(localStorage.getItem(DEL) || '{}') || {}; } catch (e) {}
      panel = document.createElement('div');
      panel.className = 'supplier-panel'; panel.hidden = true;
      panel.innerHTML = (caveats.length ? '<ul class="supplier-panel__list">' + caveats.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' : '') +
        '<div class="supplier-deliver">' +
          '<p class="supplier-deliver__head">Delivery address</p>' +
          '<label class="supplier-deliver__name">Full name<input type="text" data-supplier-addr="name" autocomplete="shipping name" maxlength="120" value="' + esc(del.name || '') + '"></label>' +
          '<label class="supplier-deliver__address1">Address line 1<input type="text" data-supplier-addr="address1" autocomplete="shipping address-line1" maxlength="120" value="' + esc(del.address1 || '') + '"></label>' +
          '<label class="supplier-deliver__address2"><span>Address line 2 <small>(optional)</small></span><input type="text" data-supplier-addr="address2" autocomplete="shipping address-line2" maxlength="120" value="' + esc(del.address2 || '') + '"></label>' +
          '<label class="supplier-deliver__city">Town or city<input type="text" data-supplier-addr="city" autocomplete="shipping address-level2" maxlength="120" value="' + esc(del.city || '') + '"></label>' +
          '<label class="supplier-deliver__zip">Postcode<input type="text" data-supplier-zip autocomplete="shipping postal-code" autocapitalize="characters" spellcheck="false" maxlength="10" value="' + esc(del.zip || '') + '"></label>' +
          '<label class="supplier-deliver__country">Country<select data-supplier-country autocomplete="shipping country">' + COUNTRIES.map(function (c) {
            return '<option value="' + c[0] + '"' + (del.country === c[0] ? ' selected' : '') + '>' + c[1] + '</option>'; }).join('') + '</select></label>' +
          '<label class="supplier-deliver__phone"><span>Mobile or phone <small>(for the courier)</small></span><input type="tel" data-supplier-addr="phone" autocomplete="shipping tel" inputmode="tel" maxlength="120" value="' + esc(del.phone || '') + '"></label>' +
        '</div>' +
        '<p class="supplier-deliver__summary" data-supplier-summary hidden></p>' +
        '<label class="supplier-ack"><input type="checkbox" data-supplier-ack><span>' + esc(ackText) + '</span></label>' +
        '<p class="supplier-min" data-supplier-min hidden></p>';
      box.insertAdjacentElement('afterend', panel);
      minEl = panel.querySelector('[data-supplier-min]');
      selEl = panel.querySelector('[data-supplier-country]');
      zipEl = panel.querySelector('[data-supplier-zip]');
      ackEl = panel.querySelector('[data-supplier-ack]');
      sumEl = panel.querySelector('[data-supplier-summary]');
      Array.prototype.forEach.call(panel.querySelectorAll('[data-supplier-addr]'), function (el) { addrEls[el.getAttribute('data-supplier-addr')] = el; });
      ackEl.addEventListener('change', function () { showErr(''); gate(); });
      var saveDel = function () {
        try { localStorage.setItem(DEL, JSON.stringify(deliveryValue())); } catch (e) {}
        Array.prototype.forEach.call(panel.querySelectorAll('[aria-invalid]'), function (el) { el.removeAttribute('aria-invalid'); });
        summary();
      };
      selEl.addEventListener('change', saveDel); zipEl.addEventListener('input', saveDel);
      Object.keys(addrEls).forEach(function (k) { addrEls[k].addEventListener('input', saveDel); });
      summary();
    }
    function addrVal(k) { return addrEls[k] ? addrEls[k].value.replace(/\s+/g, ' ').trim() : ''; }
    function deliveryValue() {
      return { name: addrVal('name'), address1: addrVal('address1'), address2: addrVal('address2'), city: addrVal('city'),
        zip: zipEl ? zipEl.value.trim() : '', country: selEl ? selEl.value : '', phone: addrVal('phone') };
    }
    function fmtZip(z) { z = String(z || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); return z.length > 3 ? z.slice(0, -3) + ' ' + z.slice(-3) : z; }
    /* Short "Delivering to" line, shown once the address looks complete. */
    function summary() {
      if (!sumEl) return;
      var d = deliveryValue();
      if (!d.name || !d.address1 || !d.city || !d.zip) { sumEl.hidden = true; return; }
      var cn = (COUNTRIES.filter(function (x) { return x[0] === d.country; })[0] || [])[1] || d.country;
      sumEl.innerHTML = '<span>Delivering to</span> ' + esc([d.name, d.address1, d.address2, d.city, fmtZip(d.zip), cn].filter(Boolean).join(', '));
      sumEl.hidden = false;
    }
    function deliveryError() {
      if (!selEl) return '';
      var bad = function (k, m) { if (addrEls[k]) addrEls[k].setAttribute('aria-invalid', 'true'); return m; };
      if (!addrVal('name')) return bad('name', 'Please add your name for delivery.');
      if (addrVal('address1').length < 3) return bad('address1', 'Please add the first line of your delivery address.');
      if (addrVal('city').length < 2) return bad('city', 'Please add your town or city.');
      var ph = addrVal('phone').replace(/[^0-9+]/g, ''); if (!/^(\+44|0044|0)?[1-9][0-9]{8,9}$/.test(ph)) return bad('phone', 'Please add a mobile or phone number for the courier.');
      var c = selEl.value, z = zipEl.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (!/^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/.test(z)) return 'Please enter your delivery postcode for the supplier parts.';
      var byPc = /^JE/.test(z) ? 'JE' : /^GY/.test(z) ? 'GG' : /^IM/.test(z) ? 'IM' : 'GB';
      if (byPc !== c) { var n = COUNTRIES.filter(function (x) { return x[0] === byPc; })[0][1]; return 'That postcode is in ' + n + '. Please check the delivery country.'; }
      return '';
    }
    function supEx() { return read().reduce(function (n, l) { return n + pence(l.exVat) * (l.qty || 1); }, 0); }
    function checkoutBtns() {
      var b = [];
      var only = document.querySelector('[data-supplier-checkout-only]'); if (only) b.push(only);
      if (form) Array.prototype.forEach.call(form.querySelectorAll('[name="checkout"]'), function (x) { b.push(x); });
      return b;
    }
    function basketEx() { return supEx() + stockEx; }
    /* Shopify cart prices are in the visitor's currency; only GBP carts can be added to the GBP minimum here.
       Otherwise the server (which prices everything in GBP) decides and shows its own message. */
    var stockKnown = true;
    function underMin() { return count() > 0 && minEx > 0 && stockKnown && basketEx() < minEx; }
    /* Disable Checkout while the whole basket (backorder + in-stock) is under the minimum. */
    function needAck() { return count() > 0 && !!ackEl && !ackEl.checked; }
    function gate() {
      var short = underMin();
      var lock = short || needAck();
      if (minEl) {
        minEl.hidden = !short;
        if (short) minEl.innerHTML = esc(minText).replace('[minimum]', '<strong>' + gbp(minEx).replace('.00', '') + '</strong>').replace('[remaining]', '<strong>' + gbp(minEx - basketEx()) + '</strong>');
      }
      checkoutBtns().forEach(function (b) {
        if (lock) { b.disabled = true; b.setAttribute('data-supplier-min-lock', ''); }
        else if (b.hasAttribute('data-supplier-min-lock')) {
          b.removeAttribute('data-supplier-min-lock');
          var ack = document.querySelector('[data-cart-holiday-ack]');
          b.disabled = !!(ack && !ack.checked && b.hasAttribute('data-cart-checkout'));
        }
      });
    }
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-cart-holiday-ack]')) setTimeout(gate, 0); });
    if (api && !/REPLACE/.test(api)) {
      fetch(api + '/config', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { minEx = Math.round(Number(c && (c.minBasketExVat || c.minSupplierExVat) || 0) * 100) || 0; gate(); })
        .catch(function () {});
    }

    /* In-stock (Shopify cart) lines: their ex-VAT value counts towards the minimum, and in a
       mixed basket each one says it will be held and sent with the backorder parts. */
    function holdNotes() {
      var on = count() > 0;
      Array.prototype.forEach.call(document.querySelectorAll('.cart-row[data-line-key] .cart-row__info'), function (info) {
        var el = info.querySelector('[data-supplier-hold]');
        var pill = info.querySelector('[data-cart-stock]'); /* Cart pills */
        if (on && !el) {
          if (pill) {
            el = document.createElement('span'); el.className = 'supplier-hold'; el.setAttribute('data-supplier-hold', '');
            el.textContent = holdNote;
            pill.appendChild(el);
          } else {
            el = document.createElement('p'); el.className = 'supplier-hold'; el.setAttribute('data-supplier-hold', '');
            el.textContent = holdText;
            var rm = info.querySelector('.cart-row__remove'); if (rm) info.insertBefore(el, rm); else info.appendChild(el);
          }
        } else if (!on && el) el.parentNode.removeChild(el);
      });
    }
    var stockTimer = null;
    function refreshStock() {
      clearTimeout(stockTimer);
      stockTimer = setTimeout(function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            stockKnown = !c || !c.currency || c.currency === 'GBP';
            stockEx = stockKnown ? ((c && c.items) || []).reduce(function (n, i) { return n + (Number(i.original_line_price) || 0); }, 0) : 0;
            holdNotes(); gate();
          }).catch(function () {});
      }, 150);
    }
    refreshStock();
    if (form && window.MutationObserver) {
      new MutationObserver(function (muts) {
        var mine = muts.every(function (m) { var n = m.target; return (box && box.contains(n)) || (panel && panel.contains(n)) || (n.closest && n.closest('[data-supplier-hold],[data-cart-stock]')); });
        if (!mine) refreshStock();
      }).observe(form, { childList: true, subtree: true, characterData: true });
    }

    function render() {
      var a = read();
      if (!box) return;
      if (!a.length) {
        box.hidden = true; box.innerHTML = '';
        if (subtotalEl) subtotalEl.hidden = true;
        if (emptyWrap) emptyWrap.hidden = true;
        if (emptyMsg) emptyMsg.hidden = false;
        if (panel) panel.hidden = true;
        holdNotes(); gate();
        return;
      }
      var sum = 0, sumEx = 0;
      box.innerHTML = '<h2 class="supplier-basket__head">Backorder parts (from supplier)</h2>' + a.map(function (l) {
        var t = lineTotals(l); sum += t.inc; sumEx += t.ex;
        var k = esc(keyOf(l));
        return '<div class="cart-row cart-row--supplier" data-supplier-key="' + k + '">' +
          '<div class="cart-row__media cart-row__media--supplier" aria-hidden="true">' +
            '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/></svg></div>' +
          '<div class="cart-row__info">' +
            '<p class="cart-row__title">' + esc(l.makeName) + ' ' + esc(l.code) + '</p>' +
            '<p class="muted">' + esc(l.description) + '</p>' +
            /* Cart pills (display only; line-item properties unchanged) */
            '<p class="cart-status supplier-basket__tag">' + (l.pattern ? '<span class="cart-status__label">Pattern/aftermarket</span>' : '') + '<span class="bo-badge">Backordered 1\u20134 weeks</span></p>' +
            '<button type="button" class="cart-row__remove supplier-basket__remove" data-supplier-remove>Remove</button>' +
          '</div>' +
          '<div class="cart-row__meta">' +
            '<div class="supplier-qty">' +
              '<button type="button" data-supplier-step="-1" aria-label="Decrease quantity">\u2212</button>' +
              '<input type="number" inputmode="numeric" min="1" max="' + QMAX + '" value="' + (l.qty || 1) + '" aria-label="Quantity" data-supplier-qty>' +
              '<button type="button" data-supplier-step="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="cart-row__line"><div class="price-vat">' +
              '<span class="price-vat__inc">' + gbp(t.inc) + ' <span class="price-vat__label">inc VAT</span></span>' +
              '<span class="price-vat__ex">' + gbp(t.ex) + ' <span class="price-vat__label">ex VAT</span></span>' +
            '</div></div>' +
          '</div>' +
        '</div>';
      }).join('');
      box.hidden = false;
      if (subtotalEl) {
        subtotalEl.innerHTML = 'Supplier parts: <strong>' + gbp(sum) + '</strong> inc VAT <span class="muted">(' + gbp(sumEx) + ' ex VAT), included in one checkout</span>';
        subtotalEl.hidden = false;
      }
      if (emptyWrap) emptyWrap.hidden = false;
      if (emptyMsg) emptyMsg.hidden = true;
      if (panel) panel.hidden = false;
      holdNotes(); gate();
    }

    function showErr(msg) {
      Array.prototype.forEach.call(errEls, function (e) { e.textContent = msg || ''; e.hidden = !msg; });
    }

    if (box) {
      box.addEventListener('click', function (e) {
        var row = e.target.closest('[data-supplier-key]');
        if (!row) return;
        var k = row.getAttribute('data-supplier-key');
        if (e.target.closest('[data-supplier-remove]')) { remove(k); render(); refreshBadgeAlways(); return; }
        var st = e.target.closest('[data-supplier-step]');
        if (st) {
          var inp = row.querySelector('[data-supplier-qty]');
          setQty(k, (parseInt(inp.value, 10) || 1) + parseInt(st.getAttribute('data-supplier-step'), 10));
          render(); refreshBadgeAlways();
        }
      });
      box.addEventListener('change', function (e) {
        var inp = e.target.closest('[data-supplier-qty]');
        if (!inp) return;
        setQty(inp.closest('[data-supplier-key]').getAttribute('data-supplier-key'), inp.value);
        render(); refreshBadgeAlways();
      });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.closest('[data-supplier-qty]')) { e.preventDefault(); e.target.blur(); }
      });
    }
    function refreshBadgeAlways() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (c) { setBadge(c && c.item_count); }).catch(function () {});
    }

    function startCheckout(btn) {
      if (!api || /REPLACE/.test(api)) { showErr('Supplier checkout isn\u2019t available right now.'); return; }
      if (underMin() || needAck()) { gate(); return; }
      var de = deliveryError();
      if (de) {
        showErr(de);
        var inv = panel && panel.querySelector('[aria-invalid="true"]');
        if (!inv && zipEl) { zipEl.setAttribute('aria-invalid', 'true'); inv = zipEl; }
        if (inv) inv.focus();
        return;
      }
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Preparing checkout\u2026'; }
      showErr('');
      var attrs = {};
      if (form) {
        Array.prototype.forEach.call(form.querySelectorAll('[name^="attributes["]'), function (i) {
          var m = i.name.match(/^attributes\[(.*)\]$/);
          if (m && i.value) attrs[m[1]] = i.value;
        });
      }
      /* Checkout resume: reuse the pending draft if nothing changed, else replace it. */
      if (btn && !btn.__coShow) {
        btn.__coShow = true;
        window.addEventListener('pageshow', function (ev) { if (ev.persisted) { btn.disabled = false; if (label) btn.textContent = label; gate(); } });
      }
      var delivery = deliveryValue();
      var coCart = null, coSig = '', prev = readLast();
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          coCart = cart; coSig = basketSig(cart, delivery);
          if (prev && prev.key && prev.sig === coSig && prev.url) {
            return lastStatus(prev).then(function (st) {
              if (st === 'open' || st === 'invoice_sent') return { reuse: true };
              if (st === 'completed') return clearOrdered(prev).then(function () { return { paid: true }; });
              return {};
            });
          }
          return {};
        })
        .then(function (d) {
          if (d.reuse) { window.location.assign(prev.url); return 'done'; }
          if (d.paid) { window.location.replace('/cart'); return 'done'; }
          var cart = coCart;
          var ca = (cart && cart.attributes) || {};
          Object.keys(ca).forEach(function (k) { if (ca[k] && !attrs[k]) attrs[k] = ca[k]; });
          return fetch(api + '/checkout', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              supplier: read().map(function (l) { return { make: l.make, code: l.code, qty: l.qty }; }),
              cart: ((cart && cart.items) || []).map(function (i) { return { variantId: i.variant_id, qty: i.quantity }; }),
              confirmPartNumbers: !!(ackEl && ackEl.checked),
              confirmShipComplete: !!(ackEl && ackEl.checked),
              delivery: delivery,
              attributes: attrs,
              note: (cart && cart.note) || '',
              replace: prev && prev.id && prev.key ? { id: prev.id, key: prev.key } : undefined
            })
          });
        })
        .then(function (r) {
          if (r === 'done') return 'done';
          return r.json().then(function (j) { if (!r.ok || !j.invoiceUrl) throw new Error(j.error || 'Checkout failed.'); return j; });
        })
        .then(function (j) {
          if (j === 'done') return;
          /* Keep both baskets: they're cleared only once this draft is paid (checkPaid). */
          var lines = { sup: read().map(keyOf), cart: {} };
          ((coCart && coCart.items) || []).forEach(function (i) { lines.cart[i.variant_id] = (lines.cart[i.variant_id] || 0) + i.quantity; });
          try { localStorage.setItem(LAST, JSON.stringify({ url: j.invoiceUrl, name: j.name, id: j.id || null, key: j.key || null, api: api, sig: coSig, lines: lines, at: Date.now() })); } catch (e) {}
          window.location.assign(j.invoiceUrl);
        })
        .catch(function (e) {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          gate();
          showErr((e && e.message) || 'Checkout failed. Please try again.');
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!count()) return;                                    // normal Shopify checkout
        var sub = e.submitter;
        if (sub && sub.name && sub.name !== 'checkout') return;  // update etc.
        var ack = document.querySelector('[data-cart-holiday-ack]');
        if (ack && !ack.checked) return;                          // theme shows its own hint
        e.preventDefault();
        startCheckout(sub || form.querySelector('[name="checkout"]'));
      });
    }
    var only = document.querySelector('[data-supplier-checkout-only]');
    if (only) only.addEventListener('click', function () { startCheckout(only); });

    /* Checkout resume: a pending (unpaid) checkout keeps the basket; say so, and offer to continue. */
    var paidName = null;
    try { paidName = sessionStorage.getItem(LAST + '-paid'); sessionStorage.removeItem(LAST + '-paid'); } catch (e) {}
    if (resume && paidName) {
      resume.innerHTML = 'Thanks, your order' + (paidName !== '1' ? ' (' + esc(paidName) + ')' : '') + ' has been placed, so those parts have been cleared from your cart.';
      resume.hidden = false;
    }
    var lastNow = readLast();
    function showPending() {
      var cur = readLast();
      if (!resume || !cur || !cur.key) return;
      checkPaid().then(function (st) {
        if (st !== 'open' && st !== 'invoice_sent') return;
        var l = readLast(); if (!l) return;
        resume.innerHTML = 'Your checkout' + (l.name ? ' (' + esc(l.name) + ')' : '') + ' is waiting for payment. Your parts are still in your cart; change anything and Checkout will update it. ' +
          '<a href="' + esc(l.url) + '" data-supplier-resume-go>Continue to checkout</a> \u00b7 <button type="button" data-supplier-resume-x>Dismiss</button>';
        resume.hidden = false;
      });
    }
    if (resume && lastNow && lastNow.key) {
      resume.addEventListener('click', function (e) { if (e.target.closest('[data-supplier-resume-x]')) resume.hidden = true; });
      showPending();
    }
    /* Back from checkout (bfcache): refresh the banner so it names the current checkout. */
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) showPending(); });
    /* Legacy: a checkout started before this fix (baskets were cleared then): offer to resume it. */
    if (resume && !(lastNow && lastNow.key)) {
      try {
        var last = JSON.parse(localStorage.getItem(LAST) || 'null');
        if (last && last.url && Date.now() - last.at < 3 * 86400000) {
          resume.innerHTML = 'You started a checkout' + (last.name ? ' (' + esc(last.name) + ')' : '') +
            '. <a href="' + esc(last.url) + '">Continue to checkout</a> \u00b7 <button type="button" data-supplier-resume-x>Dismiss</button>';
          resume.hidden = false;
          resume.addEventListener('click', function (e) {
            if (e.target.closest('[data-supplier-resume-x]')) { try { localStorage.removeItem(LAST); } catch (x) {} resume.hidden = true; }
          });
        }
      } catch (e) {}
    }

    render();
    document.addEventListener('supplier-basket:change', render);
    restoreFromLink(root);
    window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
  }

  /* Cart page: re-add the supplier lines carried by a basket link through the official add path.
     The link stands for the whole basket, so it replaces the backorder parts here (theme.js likewise
     clears the Shopify cart before re-adding ?load= lines). The tick box is never pre-ticked. */
  function restoreFromLink(root) {
    if (themeWillReload) return;
    var p = null;
    try { p = JSON.parse(sessionStorage.getItem(PENDING) || 'null'); sessionStorage.removeItem(PENDING); } catch (e) {}
    if (!p || !p.lines || !p.lines.length || Date.now() - (p.at || 0) > 5 * 60000) return;
    var head = root.querySelector('.page-title');
    var box = document.createElement('div');
    box.className = 'supplier-restore is-loading';
    box.setAttribute('role', 'status');
    box.innerHTML = '<span class="supplier-restore__spin" aria-hidden="true"></span><span>Adding the backorder parts from your cart link\u2026</span>';
    if (head) head.insertAdjacentElement('afterend', box); else root.insertBefore(box, root.firstChild);
    var stockClear = /[?&]sup=/.test(window.location.search)
      ? fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' }).catch(function () {})
      : Promise.resolve();
    try { if (/[?&](sup|load)=/.test(window.location.search)) history.replaceState(null, '', window.location.pathname); } catch (e) {}
    var failed = [], added = 0;
    stockClear.then(function (r) {
      clear();
      return p.lines.reduce(function (chain, l) {
        return chain.then(function () {
          return addChecked(l.make, l.code, l.qty, 'set').then(function (res) {
            if (res.ok) added++; else failed.push({ l: l, res: res });
          });
        });
      }, Promise.resolve()).then(function () { return r; });
    }).then(function (r) {
      box.classList.remove('is-loading');
      if (failed.length) {
        box.classList.add('is-warn');
        box.setAttribute('role', 'alert');
        box.innerHTML = '<div class="supplier-restore__body">' + failHtml(failed, 'link') +
          '<p>' + (added ? 'Everything else from the link is in your cart, at today\u2019s prices.' : 'Nothing else from the link needed adding here.') + '</p></div>' +
          '<button type="button" class="supplier-restore__x" aria-label="Dismiss">\u00d7</button>';
      } else {
        box.classList.add('is-ok');
        box.innerHTML = '<svg class="supplier-restore__tick" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>' +
          '<span>' + added + ' backorder part' + (added === 1 ? '' : 's') + ' added from the link, at today\u2019s prices.</span>' +
          '<button type="button" class="supplier-restore__x" aria-label="Dismiss">\u00d7</button>';
      }
      box.addEventListener('click', function (e) { if (e.target.closest('.supplier-restore__x')) box.parentNode && box.parentNode.removeChild(box); });
      /* Supplier-only link: the Shopify cart was just cleared, so reload once to show the basket cleanly. */
      if (r && document.querySelector('.cart-row[data-line-key]')) {
        try { sessionStorage.setItem(PENDING + '-msg', box.outerHTML); } catch (e) {}
        window.location.replace('/cart');
        return;
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (x) { return x.json(); }).then(function (c) { setBadge(c && c.item_count); }).catch(function () {});
    });
  }
  function carryMsg(root) {
    var html = null;
    try { html = sessionStorage.getItem(PENDING + '-msg'); sessionStorage.removeItem(PENDING + '-msg'); } catch (e) {}
    if (!html || !root) return;
    var head = root.querySelector('.page-title'), tmp = document.createElement('div');
    tmp.innerHTML = html;
    var box = tmp.firstChild;
    if (head) head.insertAdjacentElement('afterend', box);
    box.addEventListener('click', function (e) { if (e.target.closest('.supplier-restore__x')) box.parentNode && box.parentNode.removeChild(box); });
  }
  /* Keep the header count in step with every basket change: this page, other tabs, and Back (bfcache). */
  var badgeTimer = null;
  function queueBadge() { clearTimeout(badgeTimer); badgeTimer = setTimeout(refreshBadge, 60); }
  document.addEventListener('supplier-basket:change', queueBadge);
  window.addEventListener('storage', function (e) { if (!e.key || e.key === KEY) queueBadge(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) queueBadge(); });
  function boot() {
    refreshBadge(); carryMsg(document.querySelector('[data-supplier-cart]')); initCart();
    if (!document.querySelector('[data-supplier-cart]')) checkPaid(); /* Checkout resume: clear once paid */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
